module.exports = __webpack_public_path__ + "static/media/wp_tutorial_image_1.22304239.png";